import { render, staticRenderFns } from "./Snakebar.vue?vue&type=template&id=5d879664&scoped=true"
import script from "./Snakebar.vue?vue&type=script&lang=js"
export * from "./Snakebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d879664",
  null
  
)

export default component.exports